import { SideNav } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface SearchDocumentsSideNavLinkProps {
  path: string;
}

const SearchDocumentsSideNavLink: FC<SearchDocumentsSideNavLinkProps> = ({ path }) => {
  const { t } = useTranslation('SearchDocumentsSideNavLink');

  return (
    <SideNav.Link data-testid="SearchDocuments" to={path} external>
      {t('title')}
    </SideNav.Link>
  );
};

export default SearchDocumentsSideNavLink;
